var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCtaArrowPurple = function SvgCtaArrowPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F55A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.892 11.609 11 3.5H4.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F55A9",
    strokeLinecap: "round",
    d: "M11 9.052V3.5"
  })));
};
export { SvgCtaArrowPurple as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuODkxNiAxMS42MDg1TDExLjAwMDEgMy41SDQuOTE4NzIiIHN0cm9rZT0iIzVGNTVBOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMSA5LjA1MjI0VjMuNSIgc3Ryb2tlPSIjNUY1NUE5IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";